export const rateTypes = ['SPACING_IN_MINUTES', 'QTY_PER_HOUR'] as const;
